module.exports = __webpack_public_path__ + "static/media/landing-page-features-unit-01.77960650.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/images/landing-page/landing-page-features-unit-01.png
// module id = 242
// module chunks = 0